import st from "../styles/template.module.scss";
import { Tooltip } from 'react-tooltip';
import React, { memo, useEffect, useState } from "react";
import Input from "../components/Input/Input";
import Checkbox from "../components/Checkbox/Checkbox";
import Textarea from "../components/Textarea/Textarea";
import { useImmer } from "use-immer";
import axios from "axios";
import { optionType } from "../components/Select/types/optionTypes";
import RadioButton from "../components/RadioButton/RadioButton";
import Button from "../components/Button/Button";
import PriceOptionsLine from "./parts/PriceOptionsLine";
import Gallery from "../components/Gallery/Gallery";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../const/API";
import CSelect from "../components/Cselect/CSelect";
import icoQuestion from "../imgs/ico-question.svg";
import Modal from "../components/Modal/Modal";
import RenderContent from "../components/RenderContent/RenderContent";
import { showMore } from "../functions/functions";

let initialData = {
    id: 0,
    model_id: '',
    extra_txt: '',
    category_id: '',
    class_id: '',
    body_color_id: '-',
    interior_color_id: '-',
    seats: '-',
    manufactured: '',
    drive_type_id: '-',
    engine: '',
    engine_hp: '',
    top_speed: '',
    transmission_id: '-',
    transmission: '',
    fuel_type_id: '-',
    fuel_consumption: '',
    counterparty_id: '',
    city_id: '',
    country_id: '',
    cp_art_number: '',
    plate_number: '',
    driver_age: '',
    published: 'false',
    image_id: '',
    image_list: '',
    video_link: '',
    extra_options: '',
    currency_id: '',
    price_options: '',
    description: '',
    to100_time: '',
    wheel_size: '',
    brand_id: '',
    min_rent_period: '',
    min_drive_exp: '',
    checkedExtraOption: [],
    imgs: [],
    mainImg: '',
    daily_mileage: '',
    partner_link: '',
    isDraft: 0,
    vehicle_id: 0,
    comment: '',
    moderation_status: '',
    registration_date: '',
    insurance_expiry_date: '',
};

type counterPartyPriceType = {
    days: string,
    caption: string
};

type PriceType = { days: string, value: string };
let userPrices: Array<counterPartyPriceType> = [];
let userMillage: string;

let Prices: Array<PriceType> = [];
//получаем ExtraOptions
let extraOptions: any;
let brands: any;
let models: any;
let categories: any;
let classes: any;
let fuelTypes: any;
let transmissions: any;
let driveTypes: any;
let colors: any;
let priceOptions: any = {};
let counterparties: any;
let cities: any;
let countries: any;
let numberOfSeats: any = [
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7+' },
];

let collectData = async () => {
    //если он получены то ничего получать не надо !
    if (localStorage.getItem('user') === '101') {
        axios.get(API + '/counterparties/').then((response) => counterparties = response.data).catch((e) => console.log(e));
        axios.get(API + '/cities/').then((response) => cities = response.data).catch((e) => console.log(e));
        axios.get(API + '/countries/').then((response) => countries = response.data).catch((e) => console.log(e));
    }

    if (localStorage.getItem('user') === '202') {
        axios.get(API + '/prices/').then((response) => {
            userPrices = JSON.parse(response.data.price_pattern);
            userMillage = response.data.def_daily_mileage;
            document.title = 'Car form - ' + response.data.name;
            // console.log({response});
        }).catch((e) => console.log(e));
    }

    if (brands?.length > 0) {
        return true;
    }

    return Promise.all([
        axios.get(API + '/ExtraOptions/').then((response) => extraOptions = response.data).catch((e) => console.log(e)),
        //получаем бренды для первого поля
        axios.get(API + '/brands/').then((response) => brands = response.data).catch((e) => console.log(e)),
        //получаем модели
        axios.get(API + '/models/').then((response) => models = response.data).catch((e) => console.log(e)),
        //Получаем категории
        axios.get(API + '/categories/').then((response) => categories = response.data).catch((e) => console.log(e)),
        //получаем классы
        axios.get(API + '/classes/').then((response) => classes = response.data).catch((e) => console.log(e)),
        //получаем тип топлива
        axios.get(API + '/fueltypes/').then((response) => fuelTypes = response.data).catch((e) => console.log(e)),
        //получаем трансмиссии
        axios.get(API + '/Transmissions/').then((response) => transmissions = response.data).catch((e) => console.log(e)),
        //получаем типы приводов
        axios.get(API + '/DriveTypes/').then((response) => driveTypes = response.data).catch((e) => console.log(e)),
        //получаем цвета
        axios.get(API + '/colors/').then((response) => colors = response.data).catch((e) => console.log(e)),
        //получаем Extras
        axios.get(API + '/priceoptions/').then((response) => priceOptions = response.data).catch((e) => console.log(e)),
    ]);
}

//поля обязательные для заполнения
let validate = [
    { name: 'class_id' },
    { name: 'category_id' },
    { name: 'brand_id' },
    { name: 'model_id' },
    { name: 'fuel_type_id' },
    { name: 'transmission_id' },
    { name: 'drive_type_id' },
    { name: 'driver_age' },
    { name: 'min_drive_exp' },
    { name: 'manufactured' },
    { name: 'seats' },
    { name: 'body_color_id' },
    { name: 'interior_color_id' },
];

function AutoForm({ autoform }: any) {
    const navigate = useNavigate();
    let { carId } = useParams();
    const [isReady, setReady] = useImmer(false);
    const [checkedImages, setCheckedImages] = useImmer([]);
    const [filteredModels, setFilteredModels] = useImmer(models);
    const [filteredBrands, setFilteredBrands] = useImmer(brands);
    const [errorHeader, setErrorHeader] = useImmer(false);
    // console.log(counterparties);
    const filteredCities = () => {
        if (cities) {
            let counterparty = counterparties.filter((c: any) => c.id + '' === data.counterparty_id + '')[0];
            let country = countries.filter((c: any) => c.id + '' === data.country_id + '')[0];
            if (counterparty || country) {
                let res = cities;
                if (counterparty) {
                    res = cities.filter((c: any) => c.id + '' === counterparty.city_id + '')
                }
                if (country) {
                    res = res.filter((c: any) => c.country_id + '' === country.id + '')
                }
                return res;
            } else {
                return cities;
            }
        } else {
            return [];
        }
    }

    const filteredCountries = () => {
        if (!cities) {
            axios.get(API + '/cities/').then((response) => cities = response.data).catch((e) => console.log(e));
        }

        let city = cities?.filter((c: any) => c.id + '' === data.city_id + '')[0];
        if (city) {
            return countries.filter((country: any) => country.id + '' === city.country_id + '');
        } else {
            return countries;
        }
    }

    const onSortOfGallery = async (img: any) => {
        let canSort = true;
        img.forEach((item: string) => {
            if (item.indexOf('blob') >= 0) {
                canSort = false;
            }
        })
        // console.log(data);

        if (!canSort || data.id < 1) {
            alert('Save before you sort');
        } else {
            await axios.post(API + '/SetSort/' + (data.isDraft === 1 ? "-" : "") + data.id + "/", {
                img: img,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            // console.log({resp});
        }
    }

    useEffect(() => {
        setFilteredModels(models);
    }, [models]);

    useEffect(() => {
        setFilteredBrands(brands);
    }, [brands]);

    useEffect(() => {
        collectData().then(() => {
            if (carId !== undefined) {
                axios.get(API + '/vehicle/' + carId + '/').then((response) => {
                    setData((draft) => {
                        Object.entries(response.data).forEach((item: Array<any>) => {
                            if (typeof (draft as any)[item[0]] !== "undefined") {
                                (draft as any)[item[0]] = item[1];
                            }
                        });
                        if (typeof response.data.driver_age_effective !== "undefined") {
                            (draft as any).driver_age = response.data.driver_age_effective;
                        }
                        if (draft.daily_mileage == null || parseInt(draft.daily_mileage) < 1) {
                            if (!userMillage) {
                                userMillage = getDefDailyMileage(draft.counterparty_id);
                            }
                            draft.daily_mileage = userMillage;
                        }

                        if (typeof response.data.extra_options !== "undefined") {
                            let newExtraOptions = [...draft.checkedExtraOption];
                            let all
                            if (response?.data?.extra_options) {
                                all = [...newExtraOptions, ...JSON.parse(response.data.extra_options)];
                            } else {
                                all = [...newExtraOptions];
                            }

                            (draft as any).checkedExtraOption = Array.from(new Set(all));
                        }

                        let counterPartyId = parseInt(draft.counterparty_id);
                        if (!isNaN(counterPartyId) && counterPartyId > 0 && localStorage.getItem("user") === '101') {
                            let counterparty = counterparties.filter((cp: any) => cp.id === counterPartyId)[0];
                            if (counterparty?.city_id) {
                                let city = cities.filter((ci: any) => ci.id === counterparty.city_id)[0];
                                if (city && counterparty) {
                                    draft.counterparty_id = counterparty.id;
                                    draft.city_id = city.id;
                                    draft.country_id = city.country_id;
                                }
                            }
                        }

                        return draft;
                    });
                    const timePrice = JSON.parse(response.data.price_options);
                    if (timePrice.price !== undefined) {
                        if (userPrices.length > 0) {
                            setPrices((draft => {
                                let arr: Array<PriceType> = [];
                                userPrices.forEach((price) => {
                                    let line: PriceType = { days: "", value: "" };
                                    line.days = price.days;
                                    timePrice.price.forEach((priceItem: PriceType) => {
                                        if (priceItem.days == line.days) {
                                            line.value = priceItem.value;
                                        }
                                    })
                                    arr.push(line);
                                })
                                return arr;
                                // console.log("DRAFT");
                            }))
                        } else {
                            setPrices(timePrice.price);
                        }
                    }
                    let forExtras = { ...timePrice };
                    if (typeof forExtras.price !== "undefined") {
                        delete forExtras.price;
                    }

                    //устанавливаем поля Extras
                    setExtras(forExtras);
                    setReady(true);
                }).catch((e) => {
                    setReady(false);
                });
            } else {
                setData((draft) => {
                    if (draft.daily_mileage == null || parseInt(draft.daily_mileage) < 1 || draft.daily_mileage.length < 1) {
                        if (!userMillage) {
                            userMillage = getDefDailyMileage(draft.counterparty_id);
                        }
                        draft.daily_mileage = userMillage;
                    }
                    return draft;
                })

                if (userPrices.length > 0) {
                    setPrices((draft => {
                        let arr: Array<PriceType> = [];
                        userPrices.forEach((price) => {
                            let line: PriceType = { days: "", value: "" };
                            line.days = price.days;
                            arr.push(line);
                        })
                        return arr;
                    }))

                }
                setReady(true);
            }
        });
    }, []);
    // console.log({isReady})

    const [data, setData] = useImmer(initialData);
    const [counterPartySymbol, setCounterPartySymbol] = useImmer(null);
    const [prices, setPrices] = useImmer(Prices);
    const [extras, setExtras] = useImmer({});
    const [errors, setErrors] = useImmer(Array<string>);
    const [rejectModal, setRejectModal] = useImmer(false);
    const [newImages, setImages] = useImmer<FileList[]>([]);

    const validateFields = () => {
        setErrors(draftOfErrors => {
            validate.forEach((field) => {
                if ((data as any)[field.name] !== null) {
                    if ((data as any)[field.name].toString().trim().length === 0) {
                        if (draftOfErrors.indexOf(field.name) === -1) {
                            draftOfErrors.push(field.name);
                        }
                    } else {
                        if (draftOfErrors.includes(field.name)) {
                            if (draftOfErrors[draftOfErrors.indexOf(field.name)] !== "undefined") {
                                draftOfErrors.splice(draftOfErrors.indexOf(field.name), 1);
                            }
                        }
                    }
                }
            })

            let video_link = data.video_link;
            if (video_link != null && video_link.length > 3 && !video_link.match(/(http:|https:)?(\/\/)?(www\.)?(youtube.com|youtu.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/)) {
                if (!draftOfErrors.includes('video_link')) {
                    draftOfErrors.push('video_link')
                }
            } else {
                if (draftOfErrors.includes('video_link')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('video_link'), 1);
                }
            }

            let top_speed = parseInt(data.top_speed);
            if (data.top_speed !== null && (top_speed <= 0 || top_speed > 500 || isNaN(top_speed)) && data.top_speed.length > 0) {
                if (!draftOfErrors.includes('top_speed')) {
                    draftOfErrors.push('top_speed')
                }
            } else {
                if (draftOfErrors.includes('top_speed')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('top_speed'), 1);
                }
            }

            let daily_mileage = parseInt(data.daily_mileage);
            if (daily_mileage <= 0 || daily_mileage > 1000 || isNaN(daily_mileage)) {
                if (!draftOfErrors.includes('daily_mileage')) {
                    draftOfErrors.push('daily_mileage')
                }
            } else {
                if (draftOfErrors.includes('daily_mileage')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('daily_mileage'), 1);
                }
            }

            let to100_time = parseInt(data.to100_time);
            if (data.to100_time !== null && (to100_time <= 0 || to100_time > 30 || isNaN(to100_time)) && data.to100_time.length > 0) {
                if (!draftOfErrors.includes('to100_time')) {
                    draftOfErrors.push('to100_time')
                }
            } else {
                if (draftOfErrors.includes('to100_time')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('to100_time'), 1);
                }
            }

            let seats = parseInt(data.seats);
            if (seats < 1 || seats > 54 || isNaN(seats)) {
                if (!draftOfErrors.includes('seats')) {
                    draftOfErrors.push('seats')
                }
            }

            let manufactured = parseInt(data.manufactured);
            if (manufactured < 1901 || manufactured > new Date().getFullYear() + 1 || isNaN(manufactured)) {
                if (!draftOfErrors.includes('manufactured')) {
                    draftOfErrors.push('manufactured')
                }
            }

            let minRentalPeriod = parseInt(data.min_rent_period);
            if (data.min_rent_period !== null && (minRentalPeriod < 1 || isNaN(minRentalPeriod)) && data.min_rent_period.length > 0) {
                if (!draftOfErrors.includes('min_rent_period')) {
                    draftOfErrors.push('min_rent_period')
                }
            } else {
                if (draftOfErrors.includes('min_rent_period')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('min_rent_period'), 1);
                }
            }

            let body_color_id = parseInt(data.body_color_id);
            if (isNaN(body_color_id)) {
                if (!draftOfErrors.includes('body_color_id')) {
                    draftOfErrors.push('body_color_id')
                }
            }

            let interior_color_id = parseInt(data.interior_color_id);
            if (isNaN(interior_color_id)) {
                if (!draftOfErrors.includes('interior_color_id')) {
                    draftOfErrors.push('interior_color_id')
                }
            }

            let engine_hp = parseInt(data.engine_hp);
            if (data.engine_hp !== null && ((engine_hp <= 0 || engine_hp >= 2000) || isNaN(engine_hp)) && data.engine_hp.length > 0) {
                if (!draftOfErrors.includes('engine_hp')) {
                    draftOfErrors.push('engine_hp')
                }
            } else {
                if (draftOfErrors.includes('engine_hp')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('engine_hp'), 1);
                }
            }

            let min_drive_exp = parseInt(data.min_drive_exp);
            if ((min_drive_exp <= 0 && min_drive_exp >= 80) || isNaN(min_drive_exp)) {
                if (!draftOfErrors.includes('min_drive_exp')) {
                    draftOfErrors.push('min_drive_exp')
                }
            } else {
                if (draftOfErrors.includes('min_drive_exp')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('min_drive_exp'), 1);
                }
            }

            let driver_age = parseInt(data.driver_age);
            if ((driver_age > 0 && (driver_age < 18 || driver_age > 99)) || isNaN(driver_age)) {
                if (!draftOfErrors.includes('driver_age')) {
                    draftOfErrors.push('driver_age')
                }
            } else {
                if (draftOfErrors.includes('driver_age')) {
                    draftOfErrors.splice(draftOfErrors.indexOf('driver_age'), 1);
                }
            }

            return draftOfErrors;
        });
    };

    const onPriceOptionsLineChange = (name: string, value: string) => {
        setExtras((draft) => {
            if (value !== '---') { //признак для удаления записи при снятии галочки, в этот момент сюда пишется ---
                (draft as any)[name] = value
            } else {
                delete (draft as any)[name];
            }
        })
    }

    const changePrice = (obj: HTMLInputElement, index: number): void => {
        setPrices(draft => {
            (draft as any)[index][obj.name] = obj.value;
        })
    }

    const getDefDailyMileage = (counterPartyId: string): string => {
        if (counterparties && parseInt(counterPartyId) > 0) { //админ сюда передаст пустую строку, поэтому надо вернуть empty string
            let counterparty = counterparties.filter((cp: any) => cp.id === counterPartyId)[0];
            return counterparty?.def_daily_mileage > 0 ? counterparty.def_daily_mileage + '' : '';
        } else {
            return '';
        }
    }

    const changeHandler = (obj: Event): void => {
        const objTarget: any = obj.target;

        setData(draft => {
            (draft as any)[objTarget.name] = objTarget.value

            const addObjValue = (name: any, array: any, objKey: any) => {
                if (objTarget.name === name) {
                    let type = array.filter((c: any) => c.id + '' === objTarget.value + '')[0];
                    if (type) {
                        objKey = type.id;
                    }
                }
            }

            //смена модели
            if (objTarget.name === "brand_id") {
                if (objTarget.value + "" !== '-') {
                    setFilteredModels(() => {
                        let result;
                        if (Array.isArray(models)) {
                            result = (models as any).filter((model: any) => objTarget.value + "" === model.brand_id + "");
                        } else {
                            result = [];
                        }
                        return result;
                    });
                } else {
                    setFilteredModels(models);
                }
            }

            if (objTarget.name === "model_id") {
                if (objTarget.value + "" !== '-') {
                    let model = models.filter((m: any) => m.id + "" === objTarget.value + "")[0];
                    draft.class_id = model.class_id;
                    draft.category_id = model.category_id;
                    draft.drive_type_id = model.drive_type_id;
                    draft.fuel_type_id = model.fuel_type_id;
                    draft.transmission_id = model.transmission_id;
                    draft.video_link = model.video_link;

                    //смена бренда
                    setFilteredBrands(() => {
                        let result;
                        if (Array.isArray(brands)) {
                            result = (brands as any).filter((brand: any) => model.brand_id + "" === brand.id + "");
                        } else {
                            result = [];
                        }
                        return result;
                    })
                } else {
                    draft.class_id = '-';
                    draft.category_id = '-';
                    draft.drive_type_id = '-';
                    draft.fuel_type_id = '-';
                    draft.transmission_id = '-';
                    draft.video_link = '';
                    setFilteredBrands(brands);
                }
            }

            if (objTarget.name === "counterparty_id") {
                let counterParty = counterparties.filter((c: any) => c.id + '' === objTarget.value + '')[0];
                // console.log(counterParty, counterParty.price_pattern);

                if (counterParty) {
                    axios.get(API + '/CurrencySymbol/' + counterParty.def_currency_id + '/').then((resp) => {
                        setCounterPartySymbol(resp.data.symbol);
                    });
                    if (typeof counterParty.price_pattern == "string") {
                        counterParty.price_pattern = JSON.parse(counterParty.price_pattern);
                    }
                    //устанавливаем периоды которые нужны для данного контрагента
                    setPrices((draft) => {
                        let arr: any = [];
                        counterParty.price_pattern.forEach((item: counterPartyPriceType, key: any) => {
                            let obj = { days: '', value: '' };
                            obj.days = item.days;
                            obj.value = typeof draft[key]?.value !== "undefined" ? draft[key]?.value : "";
                            arr.push(obj);
                        })
                        return arr;

                    })
                    let city = cities.filter((c: any) => c.id + '' === counterParty.city_id + '')[0];
                    draft.city_id = counterParty.city_id;
                    if (city) {
                        draft.country_id = city.country_id;
                    }
                    // console.log(draft.daily_mileage, counterParty.def_daily_mileage);
                    let num = parseFloat(draft.daily_mileage);
                    if ((isNaN(num) || num < 1) && counterParty.def_daily_mileage) {
                        draft.daily_mileage = counterParty.def_daily_mileage;
                    }
                } else {
                    setPrices([]);
                }
            }

            addObjValue("city_id", cities, draft.country_id);
            addObjValue("fuel_type_id", fuelTypes, draft.fuel_type_id);
            addObjValue("transmission_id", transmissions, draft.transmission_id);
            addObjValue("seats", numberOfSeats, draft.seats);
            addObjValue("drive_type_id", driveTypes, draft.drive_type_id);
            addObjValue("body_color_id", colors, draft.body_color_id);
            addObjValue("interior_color_id", colors, draft.interior_color_id);

        });
    };

    const hasPriceError = (item: any, field: string) => {
        if (item && item.value == '') {
            if (item.days === 1 && item.value.length === 0 && field !== 'days') {
                if (item[field] == null) {
                    return true;
                }
                return item[field].length === 0;
            }

            if (item.days.length > 0 || item.value.length > 0) {
                if (item[field] == null) {
                    return true;
                }
                return item[field].length === 0;
            }
            if (field == 'value' && item[field] == "") {
                return true;
            }
        } else {
            return false;
        }

    }

    const changeExtraOptionsHandler = (obj: Event): void => {

        const objTarget = obj.target as HTMLInputElement;

        let newExtraOptions = JSON.parse(JSON.stringify(data.checkedExtraOption));

        if (objTarget.checked) {
            newExtraOptions.push(objTarget.name);
        } else {
            newExtraOptions.splice(newExtraOptions.indexOf(objTarget.name), 1);
        }
        setData({ ...data, checkedExtraOption: newExtraOptions });
    };

    useEffect(() => {
        if (errors.length > 0) {
            validateFields();
        }
    }, [data]);

    const reject = (isReject = '99') => {
        sendDataButton(isReject);
    }

    const sendDataButton = async (isReject = '99') => {
        validateFields();

        //перемотка к ошибке...
        let PriceHasError = false;
        //проверим на ошибки цены, ошибки нет, если все поля или заполнены или пустые на всей строке
        prices.forEach((item, index) => {
            if (!((parseFloat(item.days) > 0 && item.value) || (parseFloat(item.days) < 1 && !item.value))) {
                PriceHasError = true;
                console.log("prices error", item);
            }
        });
        if (PriceHasError) {
            document.getElementById('BlockPricesID')?.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        } else {
            setTimeout(() => {
                if (errors.length > 0) {
                    console.log(errors[0]);
                    document.getElementById('Input' + errors[0] + 'Block')?.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                }
            }, 200);
        }

        if (errors.length > 0) {
            document.querySelector('.error')?.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        }

        // Ошибки в строке extras
        let ExtrasHasErrors = false;
        Object.entries(extras).forEach(([key, value]) => {
            if (value === '') {
                ExtrasHasErrors = true;
            }
        });

        const finalNoError = (errors.length === 0) && !PriceHasError && !ExtrasHasErrors;
        //если ошибок нет, начинаем работу с изображениями.
        if (finalNoError) {
            setErrorHeader(false);
            try {
                let resp = await axios.post(API + '/savevehicle/', {
                    obj: data,
                    prices: prices,
                    extras: extras,
                    isReject: isReject,
                    isPicturesUpdate: newImages.length > 0 ? '1' : '0'
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                const d = JSON.parse(resp.data.data);
                //Если это только создана авто, то у нее вернется ID, иначе уже был
                // {"status" : 0, "message" : "Vehicle created successfully", "id" : 877}
                if (d.status === 0) {
                    if (newImages.length === 0) {
                        navigate('/cars');
                    } else {

                        //Получем ID для отправки картинок
                        let id = (d.id) ? d.id : data.id;
                        let changeId = false;
                        if (id * 1 != data.id * 1) {
                            changeId = true;
                        }
                        //посылаем картинки
                        let resp = await axios.post(API + '/UploadImgs/' + id + "/" + ((data.isDraft || changeId) ? '1/' : ''), {
                            img: newImages,
                        }, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                        //если все хорошо, то мы завершаем работу.
                        if (resp.status !== 200) {
                            alert('some error code:FR-661');
                        } else {
                            setData({ ...data, imgs: resp.data });
                            navigate('/cars');
                        }
                    }
                } else {
                    //если ошибка, говорим об этом.
                    alert(d.message);
                }
            } catch (e: any) {
                alert('Some error code:FR-672');
                console.log(e?.response?.data?.data);
            }

        } else {
            //lert('Some error code:FR-677');
            setErrorHeader(true);
            console.log("ERROR!!! CAN'T START SAVE - has some fields error FR-703");
        }
    }

    const removeImages = async (img: any = false) => {
        let resp = await axios.post(API + '/DelImgs/', {
            id: data.id,
            paths: !img ? checkedImages : [img],
            isDraft: data.isDraft
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (resp.status !== 200) {
            alert('some error code:FR-692');
        } else {
            setData({ ...data, imgs: resp.data.data });
        }
    }

    const setMainImg = async (e: MouseEvent, img: any) => {
        e.stopPropagation();
        let resp = await axios.post(API + '/SetMainPage/', {
            id: data.id,
            path: img,
            isDraft: data.isDraft
        },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        if (resp.status !== 200) {
            alert('some error code: FR-709');
        } else {
            setData({ ...data, mainImg: img });
        }
    }

    // console.log('brands', brands);
    // console.log('models', models);

    // console.log(userMillage, data);
    return (
        (!isReady) ? (<>one moment please</>) : (<>
            <Modal isShowed={rejectModal} withCloseBtn={true} onClose={() => setRejectModal(false)}>
                <div className={st.vertical} >
                    <span className={st.main_title}> Reject Model</span>
                    <label>Comment</label>
                    <Textarea name={'comment'} value={(data.comment == null) ? '' : data.comment + ''}
                        onChange={changeHandler}
                        style={{ minHeight: '100px' }} />
                    <div className={st.flex} style={{ height: '46px', gap: '20px' }}>
                        <span className={st.btn + ' ' + st.btnLightRed + ' ' + st.btnFull}
                            onClick={() => reject('1')}>Reject</span>
                        <span className={st.btn + ' ' + st.btnLightBlue + ' ' + st.btnFull}
                            onClick={() => setRejectModal(false)}>Cancel</span>
                    </div>
                </div>
            </Modal>
            <div className={st.content}>
                <div className={st.form}>
                    <div className={st.rowHeader}>{errorHeader ?
                        (<span className={st.errorHeader}>Some&nbsp;forms are&nbsp;incomplete. Please&nbsp;check the&nbsp;forms</span>) :
                        ((data.id > 0 ? 'Edit' : 'Add') + ' car')}</div>
                    <Gallery imgs={data.imgs} onChooseFiles={setImages} mainImg={data.mainImg}
                        onSort={onSortOfGallery}
                        checkImages={setCheckedImages}
                        setMainImg={setMainImg}
                        removeImages={removeImages}
                    />
                    <div className={st.vertical} id={'Inputbrand_idBlock'}>
                        <label className={st.label}>Brand<span>*</span></label>
                        <CSelect values={filteredBrands}
                            name={'brand_id'}
                            value={data.brand_id}
                            onChange={changeHandler}
                            anotherClasses={st.vertical_select}
                            isSelect2={true}
                            hasError={errors.includes('brand_id')} />
                    </div>
                    <div className={st.vertical} id={'Inputmodel_idBlock'}>
                        <label className={st.label}>Model<span>*</span></label>
                        <CSelect values={filteredModels}
                            name={'model_id'}
                            value={data.model_id}
                            onChange={changeHandler}
                            anotherClasses={st.vertical_select}
                            isSelect2={true}
                            hasError={errors.includes('model_id')} />
                    </div>
                    <div className={st.vertical}>
                        <label className={st.label}>Extra description</label>
                        <Input name={'extra_txt'} value={data.extra_txt}
                            placeholder="Text"
                            onChange={changeHandler} />
                    </div>
                    {(localStorage.getItem("user") === '101' && (
                        <>
                            <div className={st.vertical} id={'Inputcounterparty_idBlock'}>
                                <label className={st.label}>Counterparty</label>
                                <CSelect values={counterparties} name={'counterparty_id'}
                                    value={data.counterparty_id}
                                    isSelect2={true}
                                    anotherClasses={st.vertical_select}
                                    onChange={changeHandler} hasError={errors.includes('counterparty_id')} />
                            </div>
                            <div className={st.vertical} id={'Inputcountry_idBlock'}>
                                <label className={st.label}>Country<span>*</span></label>
                                <CSelect values={filteredCountries()} name={'country_id'}
                                    value={data.country_id}
                                    anotherClasses={st.vertical_select}
                                    onChange={changeHandler} hasError={errors.includes('country_id')} />
                            </div>
                            <div className={st.vertical} id={'Inputcity_idBlock'}>
                                <label className={st.label}>City<span>*</span></label>
                                <CSelect values={filteredCities()} name={'city_id'}
                                    value={data.city_id}
                                    anotherClasses={st.vertical_select}
                                    onChange={changeHandler} hasError={errors.includes('city_id')} />
                            </div>
                        </>
                    ))}
                    <div className={st.vertical} id={'Inputcategory_idBlock'}>
                        <label className={st.label}>Car category<span>*</span></label>
                        <CSelect values={categories as optionType}
                            name={'category_id'}
                            value={data.category_id}
                            onChange={changeHandler}
                            anotherClasses={st.vertical_select}
                            isSelect2={true}
                            hasError={errors.includes('category_id')} />
                    </div>
                    <div className={st.vertical} id={'InputmanufacturedBlock'}>
                        <label className={st.label}>Manufactured year<span>*</span> <img src={icoQuestion} alt={'question'}
                            data-tooltip-id="form-tooltip"
                            data-tooltip-content="Manufacturing year" /></label>
                        <Input name={'manufactured'} value={data.manufactured}
                            placeholder="Number"
                            inputValidate={'onlyNumbers'}
                            onChange={changeHandler} 
                            hasError={errors.includes('manufactured')} />
                    </div>
                    {localStorage.getItem('user') !== '202' ? (
                        <div className={st.vertical} id={'Inputclass_idBlock'}>
                            <label className={st.label}>Car class<span>*</span></label>
                            <CSelect values={classes as optionType} name={'class_id'} value={data.class_id}
                                isSelect2={true}
                                anotherClasses={st.vertical_select}
                                onChange={changeHandler} hasError={errors.includes('class_id')} />
                        </div>
                    ) : <></>}
                    <RenderContent
                        classNames={st.vertical + ' ' + st.fuelType}
                        label='Fuel type' star
                        dataValue={data.fuel_type_id}
                        array={fuelTypes}
                        name='fuel_type_id'
                        changeHandler={changeHandler}
                    />
                    <RenderContent
                        id={'Inputtransmission_idBlock'}
                        label='Transmission' star
                        dataValue={data.transmission_id}
                        array={transmissions}
                        name='transmission_id'
                        changeHandler={changeHandler}
                    />
                    <RenderContent
                        id={'InputseatsBlock'}
                        label='Number of seats' star
                        dataValue={data.seats}
                        array={numberOfSeats}
                        name='seats'
                        changeHandler={changeHandler}
                    />
                    <RenderContent
                        id={'Inputdrive_type_idBlock'}
                        label='Drive type' star
                        dataValue={data.drive_type_id}
                        array={driveTypes}
                        name='drive_type_id'
                        changeHandler={changeHandler}
                    />
                    <div className={st.cube1 + ' item_more'}>
                        <div className={st.hide_block}>
                            <div className={st.vertical} id={'Inputengine_hpBlock'}>
                                <label className={st.label}>Engine (hp) <img src={icoQuestion} alt={'question'} data-tooltip-id="form-tooltip"
                                    data-tooltip-content="Enter the engine horsepower" /></label>
                                <Input name={'engine_hp'}
                                    placeholder="Number"
                                    value={(!isNaN(parseInt(data.engine_hp)) ? parseInt(data.engine_hp).toString() : "")}
                                    inputValidate={'onlyNumbers'}
                                    errorText={'Horsepower must be between 1 and 2000'}
                                    onChange={changeHandler}
                                    hasError={errors.includes('engine_hp')} />
                            </div>
                            <div className={st.vertical}>
                                <label className={st.label}>Wheel radius</label>
                                <Input name={'wheel_size'} value={data.wheel_size}
                                    placeholder="Number"
                                    inputValidate={'onlyNumbers'}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical}>
                                <label className={st.label}>Fuel consumption <img src={icoQuestion} alt={'question'}
                                    data-tooltip-id="form-tooltip"
                                    data-tooltip-content="Litres per 100 km" /></label>
                                <Input name={'fuel_consumption'}
                                    placeholder="Number"
                                    inputValidate={'onlyNumbers'}
                                    value={(data.fuel_consumption === null ? '' : data.fuel_consumption)}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical}>
                                <label className={st.label}>Engine <img src={icoQuestion} alt={'question'} data-tooltip-id="form-tooltip"
                                    data-tooltip-content="Engine displacement (e.g., 6.2L)" /></label>
                                <Input name={'engine'} value={data.engine}
                                    placeholder="Number"
                                    inputValidate={'onlyNumbers'}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical} id={'Inputtop_speedBlock'}>
                                <label className={st.label}>Top speed (km/h) <img src={icoQuestion} alt={'question'}
                                    data-tooltip-id="form-tooltip"
                                    data-tooltip-content="Enter vehicle's top speed according to specifications" /></label>
                                <Input name={'top_speed'} value={data.top_speed}
                                    errorText={'Speed must be between 1 and 500 km/h'}
                                    placeholder="Number"
                                    inputValidate={'onlyNumbers'}
                                    hasError={errors.includes('top_speed')}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical} id={'Inputto100_timeBlock'}>
                                <label className={st.label}>0-100 (km/h) <img src={icoQuestion} alt={'question'} data-tooltip-id="form-tooltip"
                                    data-tooltip-content="Acceleration from 0 to 100 km/h (sec)" /></label>
                                <Input name={'to100_time'} value={data.to100_time}
                                    placeholder="Number"
                                    inputValidate={'onlyNumbers'}
                                    errorText={'Acceleration time must be between 1 and 30 seconds'}
                                    hasError={errors.includes('to100_time')}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical}>
                                <label className={st.label}>Registration date </label>
                                <Input name={'registration_date'}
                                    type='date'
                                    value={data.registration_date}
                                    onChange={changeHandler} />
                            </div>
                            <div className={st.vertical}>
                                <label className={st.label}>Insurance expiry date</label>
                                <Input name={'insurance_expiry_date'}
                                    type='date'
                                    value={data.insurance_expiry_date}
                                    onChange={changeHandler} />
                            </div>
                        </div>
                        <button className={st.more_btn} onClick={(e) => showMore(e, st.active)}>&nbsp;</button>
                    </div>
                    <div className={st.vertical} >
                        <label>Features</label>
                        <div className={st.cube2}>
                            {extraOptions && Object.entries(extraOptions).map(([key, value]: any) => {
                                return (<div className={st.formHorizontal} key={value.id}>
                                    <Checkbox
                                        name={value.code}
                                        value={value.code}
                                        isChecked={(data.checkedExtraOption as any).includes(value.code)}
                                        onChange={changeExtraOptionsHandler} />
                                    {value.name}
                                </div>);
                            })}
                        </div>
                    </div>
                    <RenderContent
                        classNames={st.vertical + ' item_more'}
                        id={'Inputbody_color_idBlock'}
                        label='Body color' star
                        colorBlock={true}
                        dataValue={data.body_color_id}
                        array={colors}
                        name='body_color_id'
                        showMore={(e) => showMore(e, st.active)}
                        changeHandler={changeHandler}
                    />
                    <RenderContent
                        classNames={st.vertical + ' item_more'}
                        id={'Inputinterior_color_idBlock'}
                        label='Interior color' star
                        colorBlock={true}
                        dataValue={data.interior_color_id}
                        array={colors}
                        name='interior_color_id'
                        showMore={(e) => showMore(e, st.active)}
                        changeHandler={changeHandler}
                    />
                    <div className={st.rowHeader}>Prices</div>
                    <div className={st.vertical} id={'Inputmin_rent_periodBlock'}>
                        <label className={st.label}>Minimum Rental Duration (days)</label>
                        <Input name={'min_rent_period'} value={data.min_rent_period}
                            onChange={changeHandler}
                            placeholder="Number"
                            inputValidate={'onlyNumbers'}
                            errorText={'Minimum rental period cannot be zero or negative'}
                            hasError={errors.includes('min_rent_period')} />
                    </div>
                    <div className={st.vertical} id={'Inputdriver_ageBlock'}>
                        <label className={st.label}>Driver's minimum age<span>*</span></label>
                        <CSelect values={[{ "name": "18", "id": "18", "code": "18" },
                        { "name": "19", "id": "19", "code": "19" },
                        { "name": "20", "id": "20", "code": "20" },
                        { "name": "21", "id": "21", "code": "21" },
                        { "name": "22", "id": "22", "code": "22" },
                        { "name": "23", "id": "23", "code": "23" },
                        { "name": "24", "id": "24", "code": "24" },
                        { "name": "25", "id": "25", "code": "25" },
                        { "name": "26", "id": "26", "code": "26" },
                        { "name": "27", "id": "27", "code": "27" },
                        { "name": "28", "id": "28", "code": "28" },
                        { "name": "29", "id": "29", "code": "29" },
                        { "name": "30", "id": "30", "code": "30" },
                        { "name": "31", "id": "31", "code": "31" },
                        { "name": "32", "id": "32", "code": "32" },
                        { "name": "33", "id": "33", "code": "33" },
                        { "name": "34", "id": "34", "code": "34" },
                        { "name": "35", "id": "35", "code": "35" }]}
                            isSelect2={true} name={'driver_age'}
                            value={data.driver_age + ""}
                            anotherClasses={st.vertical_select}
                            onChange={changeHandler} hasError={errors.includes('driver_age')} />

                    </div>
                    <div className={st.vertical} id={'Inputmin_drive_expBlock'}>
                        <label className={st.label}>Driver`s min experience, years<span>*</span></label>
                        <CSelect values={[{ "name": "0", "id": "0", "code": "0" },
                        { "name": "1", "id": "1", "code": "1" },
                        { "name": "2", "id": "2", "code": "2" },
                        { "name": "3", "id": "3", "code": "3" },
                        { "name": "4", "id": "4", "code": "4" },
                        { "name": "5", "id": "5", "code": "5" },
                        { "name": "6", "id": "6", "code": "6" },
                        { "name": "7", "id": "7", "code": "7" },
                        { "name": "8", "id": "8", "code": "8" },
                        { "name": "9", "id": "9", "code": "9" },
                        { "name": "10", "id": "10", "code": "10" },
                        ]}
                            isSelect2={true} name={'min_drive_exp'}
                            value={data.min_drive_exp + ""}
                            anotherClasses={st.vertical_select}
                            onChange={changeHandler} hasError={errors.includes('min_drive_exp')} />
                    </div>
                    <div className={st.vertical}>
                        <label className={st.label}>Daily mileage (km) <img src={icoQuestion} alt={'question'}
                            data-tooltip-id="form-tooltip"
                            data-tooltip-content="Maximum allowed kilometers per day." /></label>
                        <Input name={'daily_mileage'}
                            errorText={'Daily mileage limit must be between 1 and 1000 km'}
                            value={data.daily_mileage}
                            placeholder="Number"
                            inputValidate={'onlyNumbers'}
                            hasError={errors.includes('daily_mileage')}
                            onChange={changeHandler} />
                    </div>
                    <div id={'BlockPricesID'}>
                        <div className={st.cube2}>
                            <div className={st.vertical}>
                                <span className={st.rowHeader + ' ' + st.priceHead}>From Day</span>
                            </div>
                            <div className={st.vertical}>
                                <span
                                    className={st.rowHeader + ' ' + st.priceHead}>Daily Price ({localStorage.getItem('def_currency_symbol') ? localStorage.getItem('def_currency_symbol') : counterPartySymbol})</span>
                            </div>

                            {
                                prices.length > 0 && prices.map((item, index) => {
                                    return (
                                        <React.Fragment key={index + 'priceline'}>
                                            <Input name={'days'} value={item.days}
                                                isReadOnly={true}
                                                inputValidate={'onlyNumbers'}
                                                hasError={hasPriceError(item, 'days')}
                                                onChange={(e) => changePrice(e.target, index)} />
                                            <Input name={'value'} value={item.value}
                                                hasError={hasPriceError(item, 'value')}
                                                inputValidate={'onlyNumbers'}
                                                ico={'clock'}
                                                onChange={(e) => changePrice(e.target, index)} />
                                        </React.Fragment>
                                    );
                                })
                            }
                            {
                                prices.length < 1 ? (
                                    'Choose counterparty'
                                ) : ''
                            }

                        </div>
                    </div>
                    <div className={st.cube1 + ' item_more'}>
                        <div className={st.cube1 + ' ' + st.prices}>
                            {Object.entries(priceOptions).map(([key, obj]: any) => {
                                return (
                                    <PriceOptionsLine key={obj.code + data.id} obj={obj}
                                        value={(extras as any)[obj.code]}
                                        onChangeLine={onPriceOptionsLineChange} />
                                );
                            }
                            )}
                        </div>
                        <button className={st.more_btn} onClick={(e) => showMore(e, st.active)}>&nbsp;</button>
                    </div>
                    <div className={st.rowHeader}>Description</div>
                    <Textarea name={'description'} value={data.description} ico={'clock'} placeholder="Write a description of the car..."
                        onChange={changeHandler} />
                    <div className={st.vertical} id={'Inputvideo_linkBlock'}>
                        <label className={st.label}>Youtube video link <img src={icoQuestion} alt={'question'}
                            data-tooltip-id="form-tooltip"
                            data-tooltip-content="Link to your YouTube video featuring the car. If not provided, a promotional video of the model from the official dealer will be displayed." /></label>
                        <Input name={'video_link'} value={data.video_link}
                            placeholder="Link"
                            onChange={changeHandler}
                            errorText={'Please enter a valid YouTube video URL'}
                            hasError={errors.includes('video_link')}
                            ico={'clock'}
                        />
                    </div>
                    <div className={st.rowHeader + ' ' + st.published}>
                        Is published
                        <div className={st.rowCheck}>
                            <RadioButton value={'true'} isChecked={(data.published + '' === 'true')}
                                onClick={() => {
                                    setData((draft) => {
                                        draft.published = 'true'
                                    })
                                }} /> <span>Yes</span>
                        </div>
                        <div className={st.rowCheck}>
                            <RadioButton value={'false'} isChecked={(data.published + '' === 'false')}
                                onClick={() => {
                                    setData((draft) => {
                                        draft.published = 'false'
                                    })
                                }} /> <span>No</span>
                        </div>
                    </div>

                    {data?.moderation_status == 'REJECTED' ?
                        <>
                            <div className={st.rowHeader}>
                                Moderation comment
                            </div>
                            <div className={st.row}>
                                <div className={st.vertical}>
                                    <Textarea name={'comment'} value={(data.comment == "null") ? '' : data.comment}
                                        onChange={changeHandler}
                                        style={{ minHeight: '100px' }} />
                                </div>
                            </div>
                        </>
                        : <></>}
                    <div className={st.flexRight}>
                        {/*{checkedImages.length >= 1 ? (*/}
                        {/*    <Button color={"danger"} onClick={removeImages}>Delete Images</Button>*/}
                        {/*) : (<></>)}*/}
                        {/*{checkedImages.length === 1 ? (*/}
                        {/*    <Button color={"warring"} onClick={setMainPAge}>Set Main image</Button>*/}
                        {/*) : (<></>)}*/}
                        {/*<Button color={"white"}>Cancel</Button>*/}
                        {(!data.isDraft || localStorage.getItem('user') === '202') ?
                            <>
                                <Button color={"white"} onClick={() => navigate('/cars')}>Cancel</Button>
                                <Button color={"blue"} onClick={() => sendDataButton('99')}>Save</Button>
                            </>
                            : <></>
                        }
                        {(data.isDraft && localStorage.getItem('user') != '202') ?
                            <>
                                <Button color={"danger"} onClick={() => setRejectModal(true)}>Reject</Button>
                                <Button color={"blue"} onClick={() => sendDataButton('0')}>Approve</Button>
                            </> : <></>
                        }
                    </div>
                </div>
            </div>
            <Tooltip id="form-tooltip" />
        </>)

    );
}

export default memo(AutoForm);